import AEMWrapper from "aem/ComponentWrapper";
import ContainerWrapper from "concierge-alias-aem/ContainerWrapper";
import loadable from "@loadable/component";
import meta from "./aem-meta";
import React from "react";

const Component = loadable(
  () => import(/* webpackChunkName: "component-collection-carousel" */ "."),
  {
    fallback: <></>,
    ssr: false
  }
);

export default AEMWrapper(meta, Component, { wrapper: ContainerWrapper });
